function readAddressCookie() {
  var cookieName = 'address';
  var cookieValue = document.cookie.match(new RegExp(cookieName + '=([^;]*)'));

  if (cookieValue) {
    try {
      return JSON.parse(decodeURIComponent(cookieValue[1]));
    } catch (error) {
      console.error('Error parsing address cookie:', error);
      return null;
    }
  } else {
    return null;
  }
}


 
  
